import styled from 'styled-components';
import { COLORS, TYPOGRAPHY } from 'Permafrost/constants';
export const StyledFilterSelectReset = styled.p `
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  background-color: ${COLORS.oxfordBlue};
  margin-top: var(--pf-padding-2);
  padding: var(--pf-padding-2) var(--pf-padding-3);
  font-size: ${TYPOGRAPHY.fontSize.subheadSmall};

  .reset:hover {
    cursor: pointer;
  }
`;
//# sourceMappingURL=FilterSelect.styles.js.map